module.exports = __webpack_public_path__ + "img/task-avatar.eb919ecd.png";